import React, { Component } from 'react';
import { Row, Col, Button, ButtonGroup } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";
import SyncMessage from "../../components/SyncMessage";

class BidderSourcesCountry extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            sourceToUpdate: null,
            sourceToDuplicate: null,
            duplicate: null,
            sortParam: null,
            sortOrder: 1,
            sources: [],
            availableSources: [],
            syncData: null
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleSync = this.handleSync.bind(this);
        this.handleUpdateBtnClick = this.handleUpdateBtnClick.bind(this);
        this.handleDuplicateBtnClick = this.handleDuplicateBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        API.BidderSources.getAvailableSources().then(sources => {
            this.setState({ availableSources: sources });
        });

        this.loadSources();
    }

    componentWillUpdate(nextProps, nextState) {
        const { sources, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(sources, sortParam, sortOrder);

            this.setState({ sources });
        }
    }

    sortReport(sources, sortParam, sortOrder) {
        sources.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadSources() {
        this.setState({ isLoading: true });

        API.BidderSourcesCountry.get().then(sources => this.setState({ sources, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, sourceToUpdate: null, sourceToDuplicate: null, duplicate: null });
    }

    handleFormSubmit(source) {
        this.setState({
            isShowForm: false,
            isLoading: true,
            sourceToUpdate: null,
            sourceToDuplicate: null,
            duplicate: null
        });

        if(source.update) {
            const { name } = source;

            delete source.name;

            API.BidderSourcesCountry.update(name, source).then(() => this.loadSources());
        }
        else API.BidderSourcesCountry.save(source).then(() => this.loadSources());
    }

    handleUpdateBtnClick(source) {
        this.setState({ isShowForm: true,  sourceToUpdate: source });
    }

    handleDuplicateBtnClick(source) {
        this.setState({ isShowForm: true,  sourceToDuplicate: source, duplicate: true });
    }

    handleRemoveBtnClick(name) {
        this.setState({ isLoading: true });

        API.BidderSourcesCountry.remove(name).then(() => this.loadSources());
    }

    handleSync() {
        this.setState({ isLoading: true });

        API.Sync(['bidder', 'bidder-adk'], 'sources/country', 8081)
            .then((res) => {
                this.setState({ isLoading: false, syncData: { res } });
            })
            .catch(err => {
                this.setState({ isLoading: false, syncData: { reqErr: err } });
            });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                availableSources={this.state.availableSources}
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide}
                source={this.state.sourceToUpdate || this.state.sourceToDuplicate}
                duplicate={this.state.duplicate}
            />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Bidder Sources Country"/>
                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                            <Button bsStyle="info" onClick={this.handleSync}> Sync</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
                <SyncMessage {...this.state.syncData} />

                {this.getForm()}

                <Table sources={this.state.sources} onRemove={this.handleRemoveBtnClick} onUpdate={this.handleUpdateBtnClick} onDuplicate={this.handleDuplicateBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default BidderSourcesCountry;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesCountry/index.js